import { NirHelper } from '@Helpers/nir'

export const formatNir = function (nir: string, iso: string) {
  if (!nir) return ''
  if (!iso) return nir
  return NirHelper.formattedResult(nir, iso)
}